export default __webpack_public_path__ + "static/v2_horia_bw-0508f011b65ad8b3be9b92271652aa13.jpg";